import { render } from "./ThilimMenu.vue?vue&type=template&id=15446b36"
import script from "./ThilimMenu.vue?vue&type=script&lang=js"
export * from "./ThilimMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__